/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/**
 * Bundle contents (snippets/product-bundle-components.liquid): a choice bundle has one list per variant,
 * so show the selected variant's list. The form's "id" property is its variant input, hence getAttribute.
 */
document.addEventListener('variant:changed', function(event) {
  if (!(event.target instanceof HTMLFormElement) || !event.detail) {
    return;
  }

  var formId = event.target.getAttribute('id');
  var variantId = event.detail.variant && event.detail.variant.id ? String(event.detail.variant.id) : '';

  document.querySelectorAll('.product-bundle[data-form-id="' + formId + '"]').forEach(function(bundle) {
    var lists = bundle.querySelectorAll('[data-variant-id]');

    if (lists.length === 0) {
      return;
    }

    var hasVisibleList = false;

    lists.forEach(function(list) {
      list.hidden = list.getAttribute('data-variant-id') !== variantId;
      hasVisibleList = hasVisibleList || !list.hidden;
    });

    bundle.hidden = !hasVisibleList;
  });
});

/**
 * Sticky add to cart (snippets/product-sticky-add-to-cart.liquid): shown on small screens once the product
 * form's buy buttons have scrolled up out of view, hidden again when they're back. Its button clicks the
 * form's own Add to cart, so the theme adds the selected variant and opens the mini-cart as usual.
 */
(function() {
  var bar = document.querySelector('[data-sticky-atc]');

  if (!bar) {
    return;
  }

  var formId = bar.getAttribute('data-form-id');
  var pending = false;

  // Read on every check: a product change (combined listings) replaces the product info.
  var update = function() {
    pending = false;

    var form = document.forms[formId];
    var buyButtons = form ? form.querySelector('.product-form__buy-buttons') : null;
    var visible = buyButtons !== null && buyButtons.getBoundingClientRect().bottom < 0;

    bar.classList.toggle('is-visible', visible);
    document.documentElement.classList.toggle('has-sticky-atc', visible);
  };

  // By position rather than an IntersectionObserver, which says nothing when the page jumps straight past
  // the buttons (an anchor link, scroll restoration).
  var requestUpdate = function() {
    if (!pending) {
      pending = true;
      window.requestAnimationFrame(update);
    }
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  document.addEventListener('variant:changed', function() {
    setTimeout(requestUpdate, 0);
  });
  update();

  bar.addEventListener('click', function(event) {
    var button = event.target.closest('[data-sticky-atc-add]');
    var form = document.forms[formId];
    var formButton = form ? form.querySelector('[data-action="add-to-cart"]:not([disabled])') : null;

    if (!button || !formButton) {
      return;
    }

    event.preventDefault();
    formButton.click();
  });
})();
